import { render, staticRenderFns } from "./FormModuleSetting.vue?vue&type=template&id=5439aff5&scoped=true"
import script from "./FormModuleSetting.vue?vue&type=script&lang=js"
export * from "./FormModuleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5439aff5",
  null
  
)

export default component.exports